import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Subject } from 'rxjs';
import { PhotoCacheItem } from 'src/app/resources/models/photo-cache-item';

@Injectable({
  providedIn: 'root'
})
export class PhotoCacheService {
  private readonly photoDeletedSource = new Subject<string>();
  public photoDeleted$ = this.photoDeletedSource.asObservable();

  public constructor(private readonly dbService: NgxIndexedDBService) {}

  public async getPhoto(filename: string): Promise<string | undefined> {
    const photo = await this.dbService.getByKey('photoCache', filename).toPromise() as PhotoCacheItem | undefined;
    return photo ? photo.dataUrl : undefined;
  }

  public async setPhoto(filename: string, dataUrl: string): Promise<void> {
    const photo: PhotoCacheItem = { filename, dataUrl };
    await this.dbService.update('photoCache', photo).toPromise();
  }

  public async clearCache(): Promise<void> {
    await this.dbService.clear('photoCache').toPromise();
  }

  public notifyPhotoDeleted(photoName: string) {
    this.photoDeletedSource.next(photoName);
  }

  public async deletePhoto(filename: string): Promise<void> {
    await this.dbService.delete('photoCache', filename).toPromise();
  }
}
